import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { useHistory } from "./core/utils";

import { Login } from "./views/Login";
import { Home } from "./views/Home";
import { NotFound } from "./views/NotFound";
import { Products, Product } from "./views/Prodcuts";
import { Sites } from "./views/Sites";
import { ExcelSummary } from "./views/ExcelSummary";
import { ProductCityStock } from "./views/ProductCityStock";
import { ServiceCenterStock } from "./views/ServiceCenterStock";

export const Main = () => {
  const history = useHistory();
  const store = useSelector((state) => state?.Store);

  useEffect(() => {
    if (!store.user?.is_login) {
      history.push("/login/");
    }
  }, [store, history]);

  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/login/" exact component={Login} />
      <Route path="/products/" exact component={Products} />
      <Route path="/products/:id/" exact component={Product} />
      <Route path="/sites/" exact component={Sites} />
      <Route path="/excel-summary/" exact component={ExcelSummary} />
      <Route path="/product-city-stocks/" exact component={ProductCityStock} />
      <Route path="/service-center-stocks/" exact component={ServiceCenterStock} />

      <Route path="*" component={NotFound} />
    </Switch>
  );
};
